export enum CompanyFeature {
  CentralizedPayments = 'centralizedPayments',
}
